import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

const useEditUser = () => {
	const { t } = useTranslation();
	const utils = trpc.useUtils();
	const { mutate, isPending } = trpc.user.edit.useMutation({
		onMutate: async (user) => {
			toast.success(t('user.form.edit.success'));
			await utils.user.get.cancel();

			const userResponse = utils.user.get.getData();

			if (!userResponse) return;

			const optimisticUser = {
				...userResponse.user,
				...user,
			};

			utils.user.get.setData(undefined, () => {
				return { status: 200, user: optimisticUser };
			});

			return { userResponse };
		},
		onSuccess: () => {
			utils.invalidate();
		},
		onError(_, __, context) {
			if (!context?.userResponse) return;
			utils.user.get.setData(undefined, () => {
				return { status: 200, user: context?.userResponse.user };
			});
			toast.error(t('error.generic'));
		},
	});

	return { editUser: mutate, editUserLoading: isPending };
};

export default useEditUser;
